import { render, staticRenderFns } from "./PartiesManage.vue?vue&type=template&id=d399be9e&scoped=true"
import script from "./PartiesManage.vue?vue&type=script&lang=js"
export * from "./PartiesManage.vue?vue&type=script&lang=js"
import style0 from "./PartiesManage.vue?vue&type=style&index=0&id=d399be9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d399be9e",
  null
  
)

export default component.exports